import { Invoice } from '../types';

const roundCurrency = (value: number) => Math.round(value * 100) / 100;

export const getInvoiceTaxAmount = (invoice: Pick<Invoice, 'amount' | 'taxRate'>): number => {
  const subtotal = Number(invoice.amount || 0);
  const taxRate = Number(invoice.taxRate || 0);
  return roundCurrency((subtotal * taxRate) / 100);
};

export const getInvoicePayableAmount = (invoice: Pick<Invoice, 'amount' | 'taxRate'>): number => {
  return roundCurrency(Number(invoice.amount || 0) + getInvoiceTaxAmount(invoice));
};

export const getInvoicePayableAmountInPaise = (invoice: Pick<Invoice, 'amount' | 'taxRate'>): number => {
  return Math.round(getInvoicePayableAmount(invoice) * 100);
};
